export default __webpack_public_path__ + "static/media/band13.1619ca64.jfif";